import "normalize.css"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { onPhone } from "../../theme/MediaQueries"
import { HeaderText } from "../../theme/Typography"
import Footer from "../footer"
import Header from "../header"
import { Container, HorizontalLine, LimitedWidth } from "./styles"

const SubTitleContainer = styled.div`
  ${onPhone} {
    display: none;
  }
`
const SubTitle = styled.div`
  ${HeaderText}
`

const Layout = ({ children, style = {} }) => {
  return (
    <Container>
      <div>
        <LimitedWidth>
          <Header>
            <SubTitleContainer>
              <SubTitle>
                Träume verwirklichen mit dem besten Kredit schon ab 0.68%*
              </SubTitle>
            </SubTitleContainer>
          </Header>
        </LimitedWidth>
        <HorizontalLine bottom={"10px"} />

        <div style={style}>
          <LimitedWidth>
            <main>{children}</main>
          </LimitedWidth>
        </div>
      </div>
      <div>
        <HorizontalLine top={"10px"} />
        <LimitedWidth>
          <Footer />
        </LimitedWidth>
      </div>
    </Container>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
